import http from '../../../http-common';

export function requestLoadCuentasBancarias() {
    return http.get('/cuentas-bancarias');
}

export function requestSaveCuentaBancaria(cuentaBancaria) {
    return http.post('/cuentas-bancarias', cuentaBancaria);
}
